// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasFields } from "@insite/client-framework/Types/ContentItemModel";

const tabs = {
    org: {
        displayName: "Organization",
        sortOrder: 1,
    },
    social: {
        displayName: "Social",
        sortOrder: 1,
    },
};

const field = (name: string, displayName: string, tab: any = null) => ({
    name,
    displayName,
    editorTemplate: "TextField",
    defaultValue: "",
    fieldType: "General",
    tab,
});

const fields: any = [
    // organization
    field("organizationName", "Organization Name", tabs.org),
    field("description", "Organization Description", tabs.org),
    field("telephone", "Telephone", tabs.org),
    field("faxNumber", "Fax Number", tabs.org),
    field("email", "Email", tabs.org),
    field("addressCountry", "Country", tabs.org),
    field("addressLocality", "Address Locality", tabs.org),
    field("addressRegion", "State/Providence", tabs.org),
    field("streetAddress", "Street Address", tabs.org),
    field("postalCode", "Postal Code", tabs.org),
    field("logoUrl", "Logo Url", tabs.org),

    // social
    {
        name: "contactUs",
        displayName: "Contact Us Url",
        editorTemplate: "LinkField",
        defaultValue: { type: "Page", url: "" },
        fieldType: "General",
        tab: tabs.org,
    },
    {
        name: "socialLinks",
        editorTemplate: "ListField",
        getDisplay: (item: HasFields) => {
            return item.fields.url;
        },
        defaultValue: [],
        fieldType: "General",
        fieldDefinitions: [
            {
                name: "url",
                displayName: "Social Url",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
        tab: tabs.social,
    },
];

export default fields;
